import { useChamadosSteps } from "@/hooks/useChamadosSteps";
import { encerrarChamado, registrarNPS } from "@/services/chamados";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import ChamadoDetail from "./ChamadoDetail";
import ChamadoRating from "./ChamadoRating";
import ChamadosList from "./ChamadosList";
import ChamadoThanks from "./ChamadoThanks";

export function ChamadosManager() {
  const {
    currentStep,
    selectedChamado,
    rating,
    goToList,
    goToDetail,
    goToRating,
    goToThanks,
  } = useChamadosSteps();

  const [isEncerrandoChamado, setIsEncerrandoChamado] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [currentStep]);

  const handleFinalizarChamado = async () => {
    if (!selectedChamado) return;

    try {
      setIsEncerrandoChamado(true);
      const response = await encerrarChamado(selectedChamado.sac_codigo);

      if (response.sucesso) {
        toast.success(response.mensagem || "Chamado encerrado com sucesso!");
        goToRating();
      } else {
        toast.error("Erro ao encerrar chamado. Tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao encerrar chamado:", error);
      toast.error("Erro ao encerrar chamado. Tente novamente.");
    } finally {
      setIsEncerrandoChamado(false);
    }
  };

  const handleSubmitRating = async (ratingValue: number, comment: string) => {
    if (!selectedChamado) return;

    try {
      const response = await registrarNPS(
        selectedChamado.sac_codigo,
        ratingValue,
        comment,
      );

      if (response.sucesso) {
        toast.success(response.mensagem || "Avaliação registrada com sucesso!");
        goToThanks(ratingValue);
      } else {
        toast.error("Erro ao registrar avaliação. Tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao registrar NPS:", error);
      toast.error("Erro ao registrar avaliação. Tente novamente.");
    }
  };

  return (
    <div>
      {currentStep === "list" && <ChamadosList onSelectChamado={goToDetail} />}

      {currentStep === "detail" && selectedChamado && (
        <ChamadoDetail
          chamado={selectedChamado}
          onBack={goToList}
          onFinalizarChamado={handleFinalizarChamado}
          isEncerrandoChamado={isEncerrandoChamado}
        />
      )}

      {currentStep === "rating" && (
        <ChamadoRating onSubmitRating={handleSubmitRating} />
      )}

      {currentStep === "thanks" && (
        <ChamadoThanks rating={rating} onBackToList={goToList} />
      )}
    </div>
  );
}
